export const ADD_ELEMENT_TO_SCREEN = 'ADD_ELEMENT_TO_SCREEN'
export const UPDATE_ELEMENT_POSITION = 'UPDATE_ELEMENT_POSITION'
export const UPDATE_ELEMENT_POSITION_V2 = 'UPDATE_ELEMENT_POSITION_V2'
export const SET_RESIZE_STATE = 'SET_RESIZE_STATE'
export const CLEAR_RESIZE_STATE = 'CLEAR_RESIZE_STATE'
export const RESIZE_ELEMENT = 'RESIZE_ELEMENT'
export const UPDATE_LABEL = 'UPDATE_LABEL'
export const SELECT_ELEMENT = 'SELECT_ELEMENT'
export const REMOVE_ELEMENT = 'REMOVE_ELEMENT'
export const SET_HOLD = 'SET_HOLD'
export const CLEAR_SELECTIONS = 'CLEAR_SELECTIONS'
export const COPY_SELECTION = 'COPY_SELECTION'
export const PASTE = 'PASTE'
export const ADD_NEW_PAGE = 'ADD_NEW_PAGE'
export const SELECT_SCREEN = 'SELECT_SCREEN'
export const FETCH_CONTROL_TEMPLATES = 'FETCH_CONTROL_TEMPLATES'
export const TEXT_FIELD = 'TEXT_FIELD'
export const TEXT_AREA = 'TEXT_AREA'
export const BUTTON = 'BUTTON'
export const UPDATE_ELEMENT_PROP = 'UPDATE_ELEMENT_PROP'
export const FETCH_FIELDS_SCREEN = 'FETCH_FIELDS_SCREEN'
export const SHOW_ADD_NEW_FORM = 'SHOW_ADD_NEW_FORM'




// WEBPACK FOOTER //
// ./src/commons/constants.js